export const loading = (state) => state.jobconfigs.loading;
export const loaded = (state) => state.jobconfigs.loaded;
export const error = (state) => state.jobconfigs.error;
export const cmNames = (state) => state.jobconfigs.cmNames;
export const configMap = (state, cmName) => state.jobconfigs.data[cmName];
export const edit = (state, cmName) => state.jobconfigs.edit;
